import { render, staticRenderFns } from "./coachProfile.vue?vue&type=template&id=8630f1ca&"
import script from "./coachProfile.vue?vue&type=script&lang=js&"
export * from "./coachProfile.vue?vue&type=script&lang=js&"
import style0 from "./coachProfile.vue?vue&type=style&index=0&id=8630f1ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports